import { Component } from 'react';
import PropTypes from 'prop-types';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';

/**
 * @example <RequireFeatureFlag feature="isSomethingEnabled">something</RequireFeatureFlag>
 */
class RequireFeatureFlag extends Component {
  render() {
    const {
      children,
      disabled,
      feature,
      flags
    } = this.props;

    const enabled = flags[feature]

    return enabled ? children : disabled;
  }
}

RequireFeatureFlag.propTypes = {
  flags: PropTypes.objectOf(PropTypes.bool).isRequired,
  feature: PropTypes.string.isRequired,
  children: PropTypes.node,
  disabled: PropTypes.node,
};

RequireFeatureFlag.defaultProps = {
  children: null,
  disabled: null,
};

export { RequireFeatureFlag as RequireFeatureFlagBase }
export default withLDConsumer()(RequireFeatureFlag);
